import type { JSX } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from '@mui/material';
import type { ConfirmModalState } from './confirm-modal.viewmodel';
import './confirm-modal.css';

type Props = {
  state: ConfirmModalState;
  onConfirm: () => void;
  onCancel: () => void;
};

export const ConfirmModal = ({ state, onConfirm, onCancel }: Props): JSX.Element => {
  const { isOpen, title, message, confirmLabel, cancelLabel } = state;

  return (
    <Dialog open={isOpen} onClose={onCancel}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{message}</DialogContentText>
      </DialogContent>
      <DialogActions className='confirm-modal-actions'>
        <Button size='small' variant='outlined' onClick={onCancel}>
          {cancelLabel}
        </Button>
        <Button size='small' variant='contained' onClick={onConfirm}>
          {confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
